<template>
  <div class="contents1">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <div class="trophy-img">
        <img class="trophy" src="static/img/trophy.png" />
      </div>
      <div class="award-img">
        <img :src="award01" />
        <img :src="award02" />
        <br v-if="isMobile" />
        <img :src="award03" />
        <img :src="award04" />
      </div>
      <p class="text1">
        출장정비 서비스 <span>압도적 1위!</span><br />
        누적 정비건수 <span>430,000건 돌파!</span><br />
        누적 이용후기 건수 <span>100,000건!</span><br />
      </p>
      <p class="text2">카수리가 <span>유일</span>합니다.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false,
      bgImg: 'static/img/main-content/contents1.png',
      award01: 'static/img/main-content/award_01.png',
      award02: 'static/img/main-content/award_02.png',
      award03: 'static/img/main-content/award_03.png',
      award04: 'static/img/main-content/award_04.png'
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents1.png'
        this.award01 = 'static/img/main-content/award_01.png'
        this.award02 = 'static/img/main-content/award_02.png'
        this.award03 = 'static/img/main-content/award_03.png'
        this.award04 = 'static/img/main-content/award_04.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents1.png'
        this.award01 = 'static/img/mobile/main-content/award_01.png'
        this.award02 = 'static/img/mobile/main-content/award_02.png'
        this.award03 = 'static/img/mobile/main-content/award_03.png'
        this.award04 = 'static/img/mobile/main-content/award_04.png'
        this.isMobile = true
      }
    }
  }
}
</script>

<style scoped>
.contents1 {
  width: 100%;
  position: relative;
}
.contents1 .bg {
  width: 100%;
  height: auto;
  display: block;
}

.trophy-img {
  margin-bottom: 2.5%;
}
.award-img {
  margin-bottom: 3.5%;
}
/* pc */
@media (max-width: 1280px) {
  .contents1 .contents .trophy {
    width: 40px;
    height: auto;
  }
  .award-img img {
    width: 155px;
    height: auto;
  }
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 34px;
    line-height: 58px;
    color: #000000;
    margin-bottom: 2%;
  }
  .text1 span {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 58px;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 34px;
    color: #000000;
  }
  .text2 span {
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
}
@media (min-width: 1280px) {
  .contents1 .contents .trophy {
    width: 3.5vw;
    height: auto;
  }
  .award-img img {
    width: 12vw;
    height: auto;
  }
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.7vw;
    line-height: 5vw;
    color: #000000;
    margin-bottom: 2%;
  }
  .text1 span {
    font-style: normal;
    font-weight: 700;
    font-size: 2.7vw;
    line-height: 5vw;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.7vw;
    color: #000000;
  }
  .text2 span {
    font-style: normal;
    font-weight: 700;
    font-size: 2.7vw;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
}
@media (min-width: 641px) {
  .contents1 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5% 0 0 0;
    text-align: center;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents1 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .contents1 .contents .trophy {
    width: 10vw;
    height: auto;
    margin-top: 35%;
    margin-bottom: 5%;
  }
  .award-img img {
    width: 36vw;
    height: auto;
  }
  .text1 {
    margin-top: 12%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.2vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 5%;
  }
  .text1 span {
    font-style: normal;
    font-weight: 700;
    font-size: 6.2vw;
    line-height: 10vw;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 6.2vw;
    color: #000000;
  }
  .text2 span {
    font-style: normal;
    font-weight: 700;
    font-size: 6.2vw;
    color: #000000;
    background: linear-gradient(to top, #007def 10%, transparent 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents1.vue